import { PropertyDataTheftInsurance } from './components';

export const StepTwo = () => <PropertyDataTheftInsurance />;
